<!--
 * @Description:
 * @usage:
 * @FilePath: /app-monorepo-projects/packages/app-share/src/components/error.vue
-->

<template>
  <div
    class="error"
    :class="isErrTip ? 'tip' : 'full'"
  >
    <div class="delete-wrap">
      <img
        class="error-img"
        :v-show="!isErrTip"
        src="https://qzonestyle.gtimg.cn/qz-proj/weishi-mobile/img/integral/bind/fail.png?nowebp"
        :alt="msg"
      >
      <p class="txt">
        {{ msg }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
interface Props {
  msg: string,
  isErrTip: boolean,
}
const props = withDefaults(defineProps<Props>(), {
  msg: '网络出错，请稍后再试',
  isErrTip: false,
});
const {
  msg,
  isErrTip,
} = toRefs(props);

</script>

<style lang="scss" scoped>
.error {
  display: flex;
  align-items: center;
  z-index: 999;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: #000;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  &.full {
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
  &.tip {
    @include responsiveStyleSingle(width, 36, 'vw');
    @include responsiveStyleSingle(height, 36, 'vw');
    left: 50%;
    top: 50%;
    @include responsiveStyleSingle(margin-left, -18, 'vw');
    @include responsiveStyleSingle(margin-top, -18, 'vw');
    @include responsiveStyleSingle(border-radius, 15, 'vw');
    .txt {
      margin-top: 0;
      font-size: 14px;
    }
  }
  .delete-warp {
    align-items: center;
  }
  .error-img {
    @include responsiveStyleSingle(width, 32.53, 'vw');
    margin: 0 auto;
    display: block;
  }
  .txt {
    margin-top: 20px;
    font-size: 16px;
    text-align: center;
  }
}
</style>
